import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelText as _vModelText, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"bg bg-1\"></div><div class=\"d-inline-flex m-1\"><label class=\"form-label m-0 mt-1 mb-1\">Where to start :</label><a class=\"dl-template btn btn-primary m-0 ms-3\" target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://docs.google.com/spreadsheets/d/1CtoXgdeCNbCf33zM1w3Lfb_OLKWpqXTGPkHKSienXmQ/edit?usp=sharing\">Copy this Google Sheet</a><a class=\"dl-template btn btn-primary m-0 ms-3\" href=\"template.csv\">Or download a CSV template</a></div>", 2)
const _hoisted_3 = { class: "in-container mb-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "in-csv",
  class: "form-label"
}, "csv input", -1)
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "ctrl-container mb-3 d-flex justify-content-start" }
const _hoisted_7 = {
  for: "csv-delimiter",
  class: "form-label"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", {
  selected: "true",
  value: ";"
}, "Semicolon ;", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", { value: "," }, "Comma ,", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", { value: "\t" }, "Tab ⭾", -1)
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "unicode-icon ms-4" }
const _hoisted_13 = { class: "unicode-icon ms-4" }
const _hoisted_14 = { class: "out-container mb-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: "out-cfg",
  class: "form-label"
}, "Event List Output", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("textarea", {
        ref: "inCsv",
        id: "in-csv",
        class: "form-control",
        onDrop: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fileDrop && _ctx.fileDrop(...args))),
        onDragover: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.dragOverHandler && _ctx.dragOverHandler(...args))),
        value: _ctx.csvInput,
        onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.inputChangeHandler && _ctx.inputChangeHandler(...args))),
        onKeyup: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.inputChangeHandler && _ctx.inputChangeHandler(...args))),
        placeholder: "Drop your .csv-files here or copy the csv content"
      }, null, 40, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _withDirectives(_createElementVNode("label", _hoisted_7, "Chose Delimiter:", 512), [
        [_vShow, _ctx.hasInput]
      ]),
      _withDirectives(_createElementVNode("select", {
        id: "csv-delimiter",
        class: "form-control ms-1",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.csvDelimiter) = $event))
      }, _hoisted_11, 512), [
        [_vModelSelect, _ctx.csvDelimiter],
        [_vShow, _ctx.hasInput]
      ]),
      _withDirectives(_createElementVNode("i", _hoisted_12, "🢒", 512), [
        [_vShow, _ctx.hasInput]
      ]),
      _withDirectives(_createElementVNode("button", {
        class: "in-generate btn btn-primary ms-3",
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.generate && _ctx.generate(...args)))
      }, "Generate Event List", 512), [
        [_vShow, _ctx.hasInput]
      ]),
      _withDirectives(_createElementVNode("i", _hoisted_13, "🢒", 512), [
        [_vShow, _ctx.hasOutput]
      ]),
      _withDirectives(_createElementVNode("button", {
        class: "in-generate btn btn-primary ms-3",
        onClick: _cache[6] || (_cache[6] = () => _ctx.copyContent(_ctx.cfgOutput))
      }, "Copy to Clipboard", 512), [
        [_vShow, _ctx.hasOutput]
      ]),
      _withDirectives(_createElementVNode("button", {
        class: "in-generate btn btn-primary ms-3",
        onClick: _cache[7] || (_cache[7] = () => _ctx.download(_ctx.cfgOutput, 'wreckfest-event-list.cfg', 'text/plain'))
      }, "Save as File", 512), [
        [_vShow, _ctx.hasOutput]
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _withDirectives(_createElementVNode("textarea", {
        ref: "outCfg",
        id: "out-cfg",
        class: "form-control",
        disabled: "true",
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.cfgOutput) = $event)),
        placeholder: "Here will be your event list cfg content"
      }, null, 512), [
        [_vModelText, _ctx.cfgOutput]
      ])
    ], 512), [
      [_vShow, _ctx.hasOutput]
    ])
  ], 64))
}